import { AppHeader } from '@web_opxp/components';
import { ObFlowService, useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import ENV from '../../base/env';
import { isCustomObFlowActive, isSubscribe } from '../../base/historyService';
import { getMenu } from './menu';
import { getUserMenu } from './userMenuItems';

export interface IHeaderWrapperProps {
  loading: boolean;
  isPremium: boolean;
  session: string | undefined;
  // unread status: messages
  regular: number;
  // unread status: friendship requests
  friendship: number;
  // user picture
  picture?: string;
  // user is authorized
  authorized?: boolean;
  // user name/email
  alias?: string;
  isLoggedIn: boolean;
  // user menu item click handler
  onUserMenuAction: (actionType: string) => void;
  // login click handler
  onLogin: () => void;
}

export const HeaderWrapper: React.FC<IHeaderWrapperProps> = ({
  isPremium,
  session,
  loading,
  regular,
  friendship,
  picture,
  authorized,
  alias,
  isLoggedIn,
  onUserMenuAction,
  onLogin,
}) => {
  const { t, language } = useTranslation();
  const location = useLocation();

  if (!language || loading) {
    return null;
  }

  const isOnSubscribePage = isSubscribe(location);
  const obFlowActive = isCustomObFlowActive(location);
  const nextObStep = isOnSubscribePage && obFlowActive ? ObFlowService.getNextObStep('subscribe') : null;
  // getNextObUrl will return link to training app if next step is null
  const logoLink = ObFlowService.getNextObUrl(nextObStep, language, session);

  const menuLabel = authorized ? alias : t('common:Header.Menu.Login');
  const loginHandler = () => {
    if (authorized) return;
    onLogin();
  };
  const userMenu = authorized ? getUserMenu(onUserMenuAction, language, session, regular, friendship) : [];
  const navMenu = getMenu(
    isLoggedIn,
    isPremium,
    language,
    session,
    menuLabel,
    userMenu,
    regular + friendship,
    picture ?? 'default',
    loginHandler
  );

  return (
    <AppHeader
      logoLabel={t('common:Header.Logo') ?? ''}
      logoLink={logoLink}
      logoSrc={`${ENV.AssetsBaseUrl}/logo.svg`}
      menuItems={navMenu}
    />
  );
};

export default HeaderWrapper;
